import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import BlogPosts from './pages/BlogPosts';
import BlogPost from './pages/BlogPost';
import Categories from './pages/Categories';
import NotFound from './pages/NotFound';
import About from './pages/About';
import Login from './pages/Login';
import CreateAccount from './pages/CreateAccount';
import ForgetPassword from './pages/ForgetPassword';
import ResetPassword from './pages/ResetPassword';
import Profile from './pages/Profile';
import { getSiteSettings } from './services/api';
import { SiteSettings } from './types/SiteSettings';
import { SnackbarProvider, enqueueSnackbar } from 'notistack';
import { useTheme } from './context/ThemeContext';

const App = () => {
  const { theme } = useTheme();
  const [settings, setSettings] = useState<SiteSettings>();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        // setIsLoading(true)
        const { data } = await getSiteSettings();
        setSettings(data)
      } catch (error) {
        console.log("error", error);
        enqueueSnackbar((error as any).message, { variant: 'error' });
      } finally {
        // setIsLoading(false);
      }
    }
    fetchCategories()
  },[]);

  useEffect(() => {
    document.title = settings?.siteName as string;
  
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute("content", settings?.siteDescription as string);
    }
  }, [settings]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Layout content={settings}>
          <Routes>
            <Route path="/" element={<Home content={settings} />} />
            <Route path="/posts" element={<BlogPosts />} />
            <Route path="/posts/:id" element={<BlogPost />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/about" element={<About content={settings} />} />
            <Route path="/login" element={<Login />} />
            <Route path="/create-account" element={<CreateAccount />} />
            <Route path="/forget-password" element={<ForgetPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="*" element={<NotFound />} />   {/* 👈 Catch-all route */}
          </Routes>
        </Layout>
      </Router>
      <SnackbarProvider/>
    </ThemeProvider>
  );
};

export default App;
